import { useEffect, useState } from "react";
import { ArrowUp } from "lucide-react";

export default function ScrollToTop() {
  const [visible, setVisible] = useState(false);
  useEffect(() => {
    const onScroll = () => setVisible(window.scrollY > 600);
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  if (!visible) return null;
  return (
    <button
      onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}
      data-testid="scroll-top"
      aria-label="Scroll to top"
      className="fixed bottom-6 left-6 z-40 h-12 w-12 rounded-full bg-navy-900 text-gold-400 shadow-xl hover:bg-gold-500 hover:text-navy-900 transition-all hover:-translate-y-1 flex items-center justify-center"
    >
      <ArrowUp size={18} />
    </button>
  );
}
